import React from 'react';
import UISidebar2 from './UISidebar2';
const UIIdeas = ({ selectedTab, onTabChange, addClickableWrapper = false, pageClassName = '', enableClicking = false }) => {
  return (
    <div className={pageClassName}>
      <div className={`flex gap-8 ui-ideate ${addClickableWrapper ? 'ui-clickable-wrapper' : ''}`}>
        <UISidebar2 selectedTab={selectedTab} onTabChange={onTabChange} enableClicking={enableClicking} />
  <div className="ui-page">
    <div className="ui-page-topbar">
    <div className="flex gap-4 items-center">
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_1575_9407)">
<path d="M3.73199 2.83494L9.22921 4.58194L11.0875 2.72369C11.3939 2.41724 11.7842 2.20836 12.2092 2.12338L13.0685 1.95154C13.5805 1.84916 14.0319 2.30058 13.9295 2.81256L13.7576 3.67175C13.6726 4.09666 13.4637 4.48691 13.1573 4.79332L11.299 6.65163L12.9875 12.2886C13.0265 12.4186 13.0285 12.5569 12.9934 12.688L12.9885 12.7063C12.9552 12.8303 12.89 12.9433 12.7993 13.0341L12.0747 13.7591C11.7227 14.1114 11.1291 14.0166 10.9043 13.5722L8.71188 9.23836L7.15972 10.7905L7.15972 13.0744C7.15972 13.2684 7.08263 13.4545 6.94541 13.5918L6.26433 14.2728C6.07712 14.46 5.75921 14.3926 5.66417 14.1455L4.60213 11.384C4.58355 11.3357 4.54537 11.2976 4.49706 11.279L1.73536 10.2168C1.48826 10.1217 1.4208 9.80383 1.608 9.61663L2.28909 8.93554C2.42631 8.79832 2.61242 8.72123 2.80648 8.72123L5.09033 8.72123L6.64248 7.16907L2.32896 4.98692C1.87873 4.75915 1.78872 4.15476 2.15306 3.80568L2.9843 3.00926C3.07321 2.92407 3.18219 2.8627 3.30113 2.83083L3.321 2.8255C3.45609 2.78931 3.59871 2.79258 3.73199 2.83494Z" fill="#272729"/>
</g>
</svg>



                  <p>Green Meadows and Rolling Hills</p>
                  </div>

                  <svg width="5" height="7" viewBox="0 0 5 7" fill="none" xmlns="http://www.w3.org/2000/svg">
                   <path d="M1.5 6.1665L4.16667 3.49984L1.5 0.833171" stroke="#272729" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                  <div className="flex gap-4 items-center">
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M9.99512 4V16" stroke="#272729" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M4 10.0049L16 10.0049" stroke="#272729" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M5.76025 14.2461L14.2455 5.76081" stroke="#272729" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M14.2461 14.2393L5.76081 5.75398" stroke="#272729" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
</svg>

      <p>Ideas</p>
      </div>
    </div>
    <div className="ideas-tabs">
      <div className="ideas-tab">
        <span className="ideas-tab-name">Notes</span>
      </div>
      <div className="ideas-tab active">
        <span className="ideas-tab-name">Ideas</span>
      </div>
      <div className="ideas-tab">
        <span className="ideas-tab-name">Research</span>
      </div>
      <div>
        <button className="ideas-tab-add">
          <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M7 3V11" stroke="currentColor" stroke-width="1.25" stroke-linecap="round"></path>
            <path d="M3 7L11 7" stroke="currentColor" stroke-width="1.25" stroke-linecap="round"></path>
          </svg>
        </button>
      </div>
    </div>
    <div className="ui-page-content">
      <p className="bold">Ideas is your creative scratchpad. </p>
      <p>A space for half-thoughts, stray lines, and flashes of brilliance that don’t have a home yet.</p>
      <p>Or you can dump in anything that feels alive; fragments, feelings, or that one sentence that suddenly clicks everything into place.</p>
      <p>There’s also plenty of room for random dialogue that pops into your head, like...</p>
      <b>What the fuck are you talking about? You keyed my car!</b>
      <div className="flex gap-4 items-center mt-16">
      <p className="highlight">It’s not meant to be perfect. </p><div className="caret"></div></div>
      <p>It’s just a little thing that ties perfectly together with your script, in order for you to literally have everything you need in one place.</p>
    </div>
  </div>
</div>
    </div>
  );
};

export default UIIdeas;